<svg xmlns="http://www.w3.org/2000/svg" width="56" height="33" viewBox="0 0 56 33">
    <defs>
        <linearGradient id="ksvet7028a" x1="75.628%" x2="75.628%" y1="100%" y2="25.17%">
            <stop offset="0%" stop-color="#1E5EBC"/>
            <stop offset="74.762%" stop-color="#9F3F4F"/>
            <stop offset="100%" stop-color="#D90338"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g fill-rule="nonzero" stroke="url(#ksvet7028a)" stroke-width="2" transform="translate(-5 -4)">
            <path d="M6.5 5h50.7c1.086 0 1.967.88 1.967 1.968 0 1.086-.88 1.967-1.967 1.967H8.406c-1.053 0-1.906.853-1.906 1.906 0 1.052.853 1.906 1.906 1.906H57.23c1.07 0 1.936.867 1.936 1.936 0 1.07-.867 1.937-1.936 1.937H8.437c-1.07 0-1.937.867-1.937 1.936 0 1.07.867 1.937 1.937 1.937H57.23c1.07 0 1.936.867 1.936 1.937s-.867 1.936-1.936 1.936H8.437c-1.07 0-1.937.867-1.937 1.937s.867 1.937 1.937 1.937h49.349c1.073 0 1.944.87 1.944 1.943 0 1.074-.87 1.944-1.944 1.944H8.436c-1.069 0-1.936.867-1.936 1.936 0 1.07.867 1.937 1.937 1.937H60.5"/>
        </g>
    </g>
</svg>
